export default {"src":"/_next/static/media/office-building.0444dee2.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};